import { createSlice } from '@reduxjs/toolkit';

export const uplstateSlice = createSlice({
  name: 'uplstate', // Slice name
  initialState: {
  }, // Initial state (empty array in this case)
  reducers: {
    setuplState: (state, action) => {
      // Update the state with the received data
      return action.payload;
    },
  },
});

// Export the action creator
export const { setuplState } = uplstateSlice.actions;

// Export the reducer
export default uplstateSlice.reducer;